import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StrategyEntityItemType } from '../../services/strategyMap';

export interface StrategyMapReduxViewState {
  refreshKey: number;
  hardRefreshKey: number;
  strategyMapData: Record<string, { 
    data: StrategyEntityItemType; 
    scrollToId: string; 
  }>;
  currentData?: StrategyEntityItemType
}

const initialState: StrategyMapReduxViewState = {
  refreshKey: 0,
  hardRefreshKey: 0,
  strategyMapData: {},
};

const strategyMapViewSlice = createSlice({
  name: 'strategyMapView',
  initialState,
  reducers: {
    incrementRefreshKey: (state) => {
      state.refreshKey += 1;
    },
    setSMapData: (state, action: PayloadAction<{ 
      strategyMapId: string; 
      data: StrategyEntityItemType; 
      scrollToId: string; 
    }>) => {
      const { strategyMapId, data, scrollToId } = action.payload;
      state.strategyMapData[strategyMapId] = { data, scrollToId };
    },
    setSMapActive: (state, action: PayloadAction<{ 
      strategyMapId: string; 
      scrollToId: string; 
    }>) => {
      const { strategyMapId, scrollToId } = action.payload;
      state.strategyMapData[strategyMapId].scrollToId  =   scrollToId;
    },
    setCurrentSMap: (state, action: PayloadAction<StrategyEntityItemType>) => {
      const data  = action.payload;
      state.currentData = data;
    }, 
    resetSMapData: (state) => {
      state.strategyMapData = {};
      state.refreshKey = 0;
    },
  },
});

export const { incrementRefreshKey, setSMapData, setSMapActive, resetSMapData, setCurrentSMap } = strategyMapViewSlice.actions;

export default strategyMapViewSlice.reducer;
